import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const Certificate: React.FC = () => {
  const { product } = useContext(ProductContext)!;

  // only keep certificates that have at least one non-empty field
  const validCertificates = (product?.certificates ?? []).filter(cert =>
    cert.title?.trim() ||
    cert.details?.trim() ||
    cert.imageUrl?.trim() ||
    cert.linkUrl?.trim()
  );

  // if there are no “real” certificates, render nothing
  if (validCertificates.length === 0) {
    return null;
  }

  const textColor = product?.textColor || "#000000";
  const headingColor = product?.headingColor || "#000000";
  const headingFontStyle = product?.headingFontStyle;
  const fontStyle = product?.fontStyle;

  return (
    <div className="w-full max-w-2xl mx-auto px-4 font-mulish text-left">
      <h2
        className="text-base font-bold leading-tight pb-2"
        style={{
          letterSpacing: "0.01em",
          color: headingColor,
          fontFamily: headingFontStyle,
        }}
      >
        Certificates
      </h2>

      {validCertificates.map((cert, idx) => (
        <div
          key={idx}
          style={{ borderColor: "rgb(0, 123, 255)" }}
          className="border-2 p-4 rounded-md mb-5"
        >
          {cert.title && (
            <h3
              className="text-lg font-bold"
              style={{
                color: headingColor,
                fontFamily: headingFontStyle,
              }}
            >
              {cert.title}
            </h3>
          )}
          {cert.details && (
            <p
              className="text-sm mt-1"
              style={{ color: textColor, fontFamily: fontStyle }}
            >
              {cert.details}
            </p>
          )}
          {cert.imageUrl ? (
            <img
              src={cert.imageUrl}
              alt={cert.title}
              className="w-full h-auto mt-3 rounded-sm"
            />
          ) : (
            <p className="text-sm text-gray-500 mt-3">
              No certificate image available
            </p>
          )}
          {cert.linkUrl && (
            <a
              href={cert.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline text-sm mt-2 block"
            >
              View Certificate
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default Certificate;
